/* eslint arrow-body-style: 0 */
import iFrameDoc from './iFrameDoc';
import { frontendURL } from '../../../../helper/URLHelper';
import Wrapper from "../Wrapper.vue";
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/docs'),
      component: Wrapper,
      props: {
        headerTitle: 'Documentação',
        icon: 'book-open-globe',
      },
      children: [
        {
          path: '',
          name: 'menu_doc',
          component: iFrameDoc,
          roles: ['administrator', 'agent', 'seller', 'supervisor', 'analyzer', 'assistant'],
        },
      ]
    },
  ]
};
